import React, { ProviderProps, ReactNode, useMemo, useState } from "react"
import { Clip } from "./WTROKPLY";
import { post } from "../../api";

export type WTROKPROVCON = {
    clip: Clip|undefined;
    loadClip: (key: string) => void;
    clearClip: () => void;
}

const empty_clip : Clip = {
    key: "empty",
    url: "",
    title: "Empty",
    artist: "The Empties"
};

const default_clip : Clip = {
    key: "qwer",
    url: "https://music.wixstatic.com/mp3/4af535_143a3c6c2cc241b5a2dad9c8e5b1214a.mp3",
    title: "Run Like the Wind",
    artist: "DavidKBD"
};

const context = React.createContext<WTROKPROVCON>({
    clip: default_clip,
    loadClip: (key: string) => {},
    clearClip: () => {}
});

const WTROKPROV = (props: { children: ReactNode }) => {
    const [clip, setClip] = useState<Clip|undefined>(undefined);
    
    const loadClip = async (key: string) => {
        console.log("load clip: " + key);
        await post('api/clips', { key })
            .then(res => res.json())
            .then(res => {
                setClip(res.value);
            });
    }

    const clearClip = () => {
        setClip(undefined);
    };

    const value = useMemo(() : WTROKPROVCON => {
        return {
            clip,
            loadClip,
            clearClip
        }
    }, [clip]);

    return <context.Provider value={value}>
        { props.children }
    </context.Provider>
}

WTROKPROV.context = context;

export default WTROKPROV;